export const TRACKS_START = 'TRACKS_START';
export const TRACKS_SUCCESS = 'TRACKS_SUCCESS';
export const TRACKS_FAILURE = 'TRACKS_FAILURE';
export const TRACKS_RESET = 'TRACKS_RESET';
export const GET_TRACK = 'GET_TRACK';
